var $ = require('../../modules/$');
require('../../modules/es6.object.get-own-property-descriptor');
module.exports = function getOwnPropertyDescriptor(it, key){
  return $.getDesc(it, key);
};


//////////////////
// WEBPACK FOOTER
// /~/core-js/library/fn/object/get-own-property-descriptor.js
// module id = 1145
// module chunks = 0